import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import './Contatti.css'; // Importa il file CSS

const Contatti = () => {

    // Stato per gestire i dati del form
    const [formState, setFormState] = useState({
        from_name: '',
        message: ''
    });

    // Aggiorna lo stato con i nuovi valori dei campi input
    const handleInputChange = (e) => {
        setFormState({
            ...formState,
            [e.target.name]: e.target.value
        });
    };

    // Funzione per validare il formato dell'email
    const isValidEmail = (email) => {
        const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return emailPattern.test(email);
    };

    // Gestisce l'invio del form
    const sendEmail = (e) => {
        e.preventDefault();

        // Validazione dell'email
        if (!isValidEmail(formState.from_name)) {
            alert('Per favore inserisci un indirizzo email valido.');
            return; // Esci dalla funzione se l'email non è valida
        }

        emailjs.send('service_4o3dmto', 'template_83o8rb4', formState, '1EJxzIY_j_ZVgVQYs')
            .then((result) => {
                console.log(result.text);
                alert('Messaggio inviato con successo!');
            }, (error) => {
                console.log(error.text);
                alert('Errore nell\'invio del messaggio.');
            });
    };

    return (
        <div className="container">
            <img src="contattaci.jpg" alt="Contattaci" width="100%" />
            <div className="contatti-container">
                <form onSubmit={sendEmail}>
                    <div className="contatti">
                        <p>Compila il modulo qui sotto per richiedere informazioni o ricevere assistenza</p>
                        <input
                            type="text"
                            name="from_name"
                            value={formState.from_name}
                            onChange={handleInputChange}
                            placeholder="Inserisci la tua e-mail"
                            required
                        />
                        <textarea
                            name="message"
                            value={formState.message}
                            onChange={handleInputChange}
                            placeholder="Scrivi qui il tuo messaggio"
                            required
                        />
                        <button type="submit">Invia</button>
                    </div>
                </form>
                <div className="info">
                    <h3>Altre informazioni di contatto</h3>
                    <p>
                        <img src="icon/phone.png" alt="Telefono" width="20" />
                        Telefono:&nbsp;<a href="tel:+393491242543"> +39 349 124 2543</a>
                    </p>
                    <p>
                        <img src="icon/placeholder.png" alt="Indirizzo" width="20" />
                        Indirizzo: Via Ghislanzoni 16/3, 23885 Calco (LC), Italia
                    </p>
                    <p>
                        <img src="icon/email.png" alt="Mail" width="20" />
                        Amministrazione:&nbsp;<a href="mailto:admin@rimasoft.it">admin@rimasoft.it</a>
                    </p>
                    <p>
                        <img src="icon/email.png" alt="Mail" width="20" />
                        Supporto tecnico:&nbsp;<a href="mailto:support@rimasoft.it">support@rimasoft.it</a>
                    </p>
                    <p>
                        <img src="icon/email.png" alt="Mail" width="20" />
                        Informazioni:&nbsp;<a href="mailto:info@rimasoft.it">info@rimasoft.it</a>
                    </p>
                    {/*<div className="map-container">*/}
                    {/*    <iframe*/}
                    {/*        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2822.5572046554133!2d9.188544315606074!3d45.46368807910151!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4786c6a5db4d5ad3%3A0xe1978c87e8cbfb5f!2sVia%20Roma%2C%2012%2C%2020114%20Milano%20MI!5e0!3m2!1sit!2sit!4v1696367819826!5m2!1sit!2sit"*/}
                    {/*        width="100%"*/}
                    {/*        height="100%"*/}
                    {/*        style={{ border: 0 }}*/}
                    {/*        allowFullScreen=""*/}
                    {/*        loading="lazy"*/}
                    {/*        title="Mappa della sede"*/}
                    {/*    ></iframe>*/}
                    {/*</div>*/}
                </div>
            </div>
        </div>
    );
};

export default Contatti;
